/**
 * @generated SignedSource<<c509778b62eb6107df6b459a12927f0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateVideoElementV2Input = {
  clientMutationId?: string | null;
  eLearningContentNodeId: string;
  title: string;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type createVideoElementButton_createVideoElementMutation$variables = {
  input: CreateVideoElementV2Input;
};
export type createVideoElementButton_createVideoElementMutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly createVideoElement: {
        readonly eLearningContentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"contentCard_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type createVideoElementButton_createVideoElementMutation = {
  response: createVideoElementButton_createVideoElementMutation$data;
  variables: createVideoElementButton_createVideoElementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeringTypeText",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createVideoElementButton_createVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "createVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "eLearningContentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "contentCard_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createVideoElementButton_createVideoElementMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "CreateVideoElementV2Payload",
                "kind": "LinkedField",
                "name": "createVideoElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "eLearningContentNode",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "definitionType",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentKind",
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "elements",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "elementType",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isElementV2"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "file",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FileElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "availableSourceTypes",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "videoSource",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "sourceType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "vimeoId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Vimeo_VimeoVideoSource",
                                                "kind": "LinkedField",
                                                "name": "vimeoVideoSource",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "VimeoVideoElementSourceV2",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "folder",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "S3VideoElementSourceV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "VideoElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "question",
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "answeringType",
                                        "storageKey": null
                                      },
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerOptionV2",
                                        "kind": "LinkedField",
                                        "name": "answerOptions",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "answer",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCorrect",
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MultipleChoiceElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "MarkMistakesElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "podcastFile",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TimestampWithImage",
                                        "kind": "LinkedField",
                                        "name": "timestampsWithImage",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "start",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "end",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "imageFile",
                                            "plural": false,
                                            "selections": (v6/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PodcastWithTimestamp",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "cells",
                                        "plural": true,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v3/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "xIdx",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "yIdx",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v13/*: any*/),
                                            "type": "DisplayMatrixElementCell",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatrixElementCellCorrectAnswer",
                                                "kind": "LinkedField",
                                                "name": "correctAnswer",
                                                "plural": false,
                                                "selections": (v13/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "MatrixElementCellWrongAnswer",
                                                "kind": "LinkedField",
                                                "name": "wrongAnswers",
                                                "plural": true,
                                                "selections": [
                                                  (v12/*: any*/),
                                                  (v3/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "AnswerMatrixElementCell",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "MatrixElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "readMore",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "readMoreButtonText",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "EnhancedTextElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderItem",
                                        "kind": "LinkedField",
                                        "name": "orderItems",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OrderElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "additionalWords",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ClozeTextElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "TextElementV2",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "task",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TextWithPagesPage",
                                        "kind": "LinkedField",
                                        "name": "pages",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "internalTitle",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v11/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v10/*: any*/),
                                                "type": "TextWithPagesTextPageData",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v7/*: any*/)
                                                ],
                                                "type": "TextWithPagesImagePageData",
                                                "abstractKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "TextWithPagesElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Persolog_Class",
                                        "kind": "LinkedField",
                                        "name": "classes",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v9/*: any*/),
                                          (v14/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Persolog_Question",
                                        "kind": "LinkedField",
                                        "name": "questions",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Persolog_QuestionClass",
                                            "kind": "LinkedField",
                                            "name": "questionClasses",
                                            "plural": true,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v14/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Persolog_PersologElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "ReminderElement",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "enableSolutionReveal",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "solutionText",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "FreeTextSelfCheckElement",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80eec16c919f94682da1efaccb5a0162",
    "id": null,
    "metadata": {},
    "name": "createVideoElementButton_createVideoElementMutation",
    "operationKind": "mutation",
    "text": "mutation createVideoElementButton_createVideoElementMutation(\n  $input: CreateVideoElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      createVideoElement(input: $input) {\n        eLearningContentNode {\n          ...contentCard_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ClozeTextElementForm_ClozeTextElementFragment on ClozeTextElementV2 {\n  id\n  title\n  text\n  additionalWords\n}\n\nfragment EditOrderItemButton_OrderItemFragment on OrderItem {\n  id\n  text\n}\n\nfragment MarkMistakeElementForm_MarkMistakeElementFragment on MarkMistakesElement {\n  id\n  title\n  text\n}\n\nfragment OrderElementForm_OrderElementFragment on OrderElement {\n  id\n  title\n  answeringTypeText\n  orderItems {\n    id\n    ...OrderItemForm_OrderItemFragment\n  }\n}\n\nfragment OrderItemForm_OrderItemFragment on OrderItem {\n  id\n  text\n  ...EditOrderItemButton_OrderItemFragment\n  ...RemoveOrderItemButton_OrderItemFragment\n}\n\nfragment PodcastWithTimestampElementForm_PodcastWithTimestampElementFragment on PodcastWithTimestamp {\n  id\n  title\n  podcastFile {\n    id\n    name\n  }\n  timestampsWithImage {\n    start\n    end\n    imageFile {\n      id\n      name\n    }\n  }\n}\n\nfragment RemoveOrderItemButton_OrderItemFragment on OrderItem {\n  id\n}\n\nfragment answerMatrixElementCellForm_AnswerMatrixElementCellFragment on AnswerMatrixElementCell {\n  xIdx\n  yIdx\n  correctAnswer {\n    content\n  }\n  wrongAnswers {\n    content\n    id\n  }\n  ...editAnswersMatrixElementCellDialogForm_AnswersMatrixElementCellFragment\n}\n\nfragment contentCard_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      contentKind\n    }\n  }\n  ...elearningContentEditor_TreeNodeFragment\n}\n\nfragment displayMatrixElementCellForm_DisplayMatrixElementCellFragment on DisplayMatrixElementCell {\n  id\n  content\n  xIdx\n  yIdx\n}\n\nfragment editAnswersMatrixElementCellDialogForm_AnswersMatrixElementCellFragment on AnswerMatrixElementCell {\n  id\n  correctAnswer {\n    content\n  }\n  wrongAnswers {\n    content\n    id\n  }\n  ...editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment\n}\n\nfragment editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment on AnswerMatrixElementCell {\n  id\n}\n\nfragment elearningContentEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      elements {\n        __typename\n        id\n        elementType\n        title\n        ...elementForm_ElementV2Fragment\n      }\n    }\n  }\n}\n\nfragment elementForm_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  title\n  elementType\n  ... on FileElementV2 {\n    ...fileElementForm_FileElementV2Fragment\n  }\n  ... on VideoElement {\n    ...videoElementForm_VideoElementFragment\n  }\n  ... on MultipleChoiceElementV2 {\n    ...multipleChoiceElementForm_MultipleChoiceElementV2Fragment\n  }\n  ... on MarkMistakesElement {\n    ...MarkMistakeElementForm_MarkMistakeElementFragment\n  }\n  ... on PodcastWithTimestamp {\n    ...PodcastWithTimestampElementForm_PodcastWithTimestampElementFragment\n  }\n  ... on MatrixElement {\n    ...matrixElementForm_MatrixElementFragment\n  }\n  ... on EnhancedTextElement {\n    ...enhancedTextElementForm_EnhancedTextElementFragment\n  }\n  ... on OrderElement {\n    ...OrderElementForm_OrderElementFragment\n  }\n  ... on ClozeTextElementV2 {\n    ...ClozeTextElementForm_ClozeTextElementFragment\n  }\n  ... on TextElementV2 {\n    ...textElementForm_TextElementFragment\n  }\n  ... on TextWithPagesElement {\n    ...textWithPagesElementForm_TextWithPagesElementFragment\n  }\n  ... on Persolog_PersologElement {\n    ...persologElementForm_PersologElementFragment\n  }\n  ... on ReminderElement {\n    ...reminderElementForm_ReminderElementFragment\n  }\n  ... on FreeTextSelfCheckElement {\n    ...freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment\n  }\n}\n\nfragment enhancedTextElementForm_EnhancedTextElementFragment on EnhancedTextElement {\n  id\n  title\n  text\n  readMore\n  readMoreButtonText\n}\n\nfragment fileElementForm_FileElementV2Fragment on FileElementV2 {\n  id\n  title\n  file {\n    id\n    name\n    url\n  }\n}\n\nfragment freeTextSelfCheckElementForm_FreeTextSelfCheckElementFragment on FreeTextSelfCheckElement {\n  id\n  title\n  text\n  enableSolutionReveal\n  solutionText\n}\n\nfragment matrixElementForm_MatrixElementFragment on MatrixElement {\n  id\n  title\n  ...matrixFieldElement_MatrixElementFragment\n}\n\nfragment matrixFieldElement_MatrixElementFragment on MatrixElement {\n  id\n  cells {\n    __typename\n    id\n    kind\n    xIdx\n    yIdx\n    ... on DisplayMatrixElementCell {\n      ...displayMatrixElementCellForm_DisplayMatrixElementCellFragment\n    }\n    ... on AnswerMatrixElementCell {\n      ...answerMatrixElementCellForm_AnswerMatrixElementCellFragment\n    }\n  }\n}\n\nfragment multipleChoiceElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n    name\n  }\n  answeringType\n  answeringTypeText\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n      name\n    }\n  }\n}\n\nfragment persologClassForm_PersologClassFragment on Persolog_Class {\n  title\n  text\n  classType\n  image {\n    id\n    name\n  }\n}\n\nfragment persologElementForm_PersologElementFragment on Persolog_PersologElement {\n  id\n  title\n  classes {\n    title\n    text\n    classType\n    image {\n      id\n      name\n    }\n    ...persologClassForm_PersologClassFragment\n  }\n  questions {\n    id\n  }\n  ...persologElementQuestionsEditor_QuestionsFragment\n}\n\nfragment persologElementQuestionClassForm_PersologQuestionClassFragment on Persolog_QuestionClass {\n  text\n  classType\n}\n\nfragment persologElementQuestionFormDialog_PersologElementFragment on Persolog_PersologElement {\n  ...persologElementQuestionForm_PersologElementFragment\n}\n\nfragment persologElementQuestionFormDialog_QuestionFragment on Persolog_Question {\n  title\n  ...persologElementQuestionForm_QuestionFragment\n}\n\nfragment persologElementQuestionForm_PersologElementFragment on Persolog_PersologElement {\n  classes {\n    classType\n    title\n  }\n}\n\nfragment persologElementQuestionForm_QuestionFragment on Persolog_Question {\n  id\n  title\n  questionClasses {\n    text\n    classType\n    ...persologElementQuestionClassForm_PersologQuestionClassFragment\n  }\n}\n\nfragment persologElementQuestionsEditor_QuestionsFragment on Persolog_PersologElement {\n  id\n  ...persologElementQuestionFormDialog_PersologElementFragment\n  questions {\n    id\n    title\n    ...persologElementQuestionFormDialog_QuestionFragment\n  }\n}\n\nfragment reminderElementForm_ReminderElementFragment on ReminderElement {\n  id\n  title\n  text\n}\n\nfragment textElementForm_TextElementFragment on TextElementV2 {\n  id\n  title\n  text\n}\n\nfragment textWithPagesElementForm_TextWithPagesElementFragment on TextWithPagesElement {\n  id\n  title\n  task\n  ...textWithPagesElementPagesEditor_PagesFragment\n}\n\nfragment textWithPagesElementPageFormDialog_PageFragment on TextWithPagesPage {\n  internalTitle\n  ...textWithPagesElementPageForm_TextWithPagesPageFragment\n}\n\nfragment textWithPagesElementPageForm_TextWithPagesPageFragment on TextWithPagesPage {\n  internalTitle\n  data {\n    __typename\n    kind\n    ... on TextWithPagesTextPageData {\n      text\n    }\n    ... on TextWithPagesImagePageData {\n      image {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment textWithPagesElementPagesEditor_PagesFragment on TextWithPagesElement {\n  id\n  pages {\n    id\n    internalTitle\n    data {\n      __typename\n      kind\n    }\n    ...textWithPagesElementPageFormDialog_PageFragment\n  }\n}\n\nfragment videoElementForm_VideoElementFragment on VideoElement {\n  id\n  title\n  availableSourceTypes\n  videoSource {\n    __typename\n    sourceType\n    ... on VimeoVideoElementSourceV2 {\n      vimeoId\n      vimeoVideoSource {\n        id\n      }\n    }\n    ... on S3VideoElementSourceV2 {\n      folder\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c99849994db19227a9cf92fbb766eca0";

export default node;
